import { Action } from '../../../actions';
import { ExternalResourceData } from '../reducer/externalResources';

export enum ExternalResourcesActionKeys {
	GET_DATA = '@@editor/externalResources/GET_DATA',
	SET_DATA = '@@editor/externalResources/SET_DATA',
	RESET_LOADING = '@@editor/externalResources/RESET_LOADING',
}

interface GetDataAction extends Action {
	type: ExternalResourcesActionKeys.GET_DATA;
	id: number;
}

interface SetDataAction extends Action {
	type: ExternalResourcesActionKeys.SET_DATA;
	id: number;
	data: ExternalResourceData;
}

interface ResetLoadingAction extends Action {
	type: ExternalResourcesActionKeys.RESET_LOADING;
	id: number;
}

export type ExternalResourcesAction =
	GetDataAction |
	SetDataAction |
	ResetLoadingAction;

export const getExternalResourcesData = (id: number): GetDataAction => ({
	type: ExternalResourcesActionKeys.GET_DATA,
	id,
});

export const setExternalResourcesData = (id: number, data: ExternalResourceData): SetDataAction => ({
	type: ExternalResourcesActionKeys.SET_DATA,
	id,
	data,
});

export const resetExternalResourcesLoading = (id: number): ResetLoadingAction => ({
	type: ExternalResourcesActionKeys.RESET_LOADING,
	id,
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/actions/externalResources.ts